module.exports = __webpack_public_path__ + "static/media/SEVEN.0a8177f4.png";